import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import VueI18n from 'vue-i18n'

import ru from 'vuetify/es5/locale/ru'

Vue.use(Vuetify)
Vue.use(VueI18n)

export default new Vuetify({
  lang: {
    locales: { ru },
    current: 'ru'
  },
  theme: {
    themes: {
      light: {
        primary: '#007bff',
        secondary: '#9cf',
        accent: '#8c9eff',
        error: '#b71c1c'
      },
      dark: {
        primary: '#007bff',
        secondary: '#424242',
        accent: '#FF4081',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00'
      }
    }
  }
})
